import { render, staticRenderFns } from "./ClientGrantTypeSave.vue?vue&type=template&id=055f70f6&scoped=true&"
import script from "./ClientGrantTypeSave.vue?vue&type=script&lang=ts&"
export * from "./ClientGrantTypeSave.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055f70f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('055f70f6')) {
      api.createRecord('055f70f6', component.options)
    } else {
      api.reload('055f70f6', component.options)
    }
    module.hot.accept("./ClientGrantTypeSave.vue?vue&type=template&id=055f70f6&scoped=true&", function () {
      api.rerender('055f70f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/clientConfiguration/clientGrantType/ClientGrantTypeSave.vue"
export default component.exports